import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Cta } from '../common';
import { EXT, openExternal } from '../../config/links';
import TradingTerminal from '../TradingTerminal';

export default function Hero() {
  return (
    <section className="relative pt-[140px] pb-16 overflow-hidden">
      <div className="absolute inset-0 grid-bg" />
      <div className="absolute inset-0 gold-glow-top" />
      <div className="container-x relative">
        <div className="flex flex-col items-center text-center">
          <div className="tag mb-6"><span className="dot-pulse" /> Institutional-grade trading intelligence</div>
          <h1 className="font-display font-bold tracking-tight" style={{ fontSize: 'clamp(36px, 6vw, 76px)', lineHeight: 1.03, letterSpacing: '-0.035em', maxWidth: 960 }}>
            <span className="silver-text">AI That Turns Market Data</span><br /><span className="gold-text">Into Trade Decisions.</span>
          </h1>
          <p className="mt-6 text-[18px] leading-relaxed text-[var(--muted)] max-w-[720px]">
            Kalki AI combines intelligent market scanning, quantitative strategies, backtesting and multi-account execution into one institutional-grade trading platform.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-center gap-3">
            <Cta size="lg" href={EXT.SIGNUP} onClick={() => openExternal(EXT.SIGNUP, 'hero_cta_click')}>Start Trading <ArrowRight size={18} /></Cta>
            <Link to="/platform" className="btn-outline inline-flex items-center justify-center gap-2 rounded-xl h-14 px-9 text-[16px] font-semibold">Explore the Platform</Link>
          </div>
          <p className="mt-6 font-mono text-[12px] text-[var(--muted-2)] tracking-wide">Crypto · US Tech · Forex · Commodities</p>
        </div>
        <div className="mt-16 reveal"><TradingTerminal /></div>
      </div>
    </section>
  );
}
